import React, { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, IconButton, Link, Typography } from '@mui/material';
import { CloseRounded, KeyRounded } from '@mui/icons-material';
import {
  clearRecoveryCodeSignIn,
  recoveryCodeSignIn
} from '../../../utils/recoveryCodes';
import { PT } from '../../../components/portalUi';

/* After a sign-in on a recovery code (the 2FA step records it — utils/recoveryCodes):
 * the member could not use their authenticator, so the portal says how many codes are
 * left and sends them to set 2FA up on the device they have now. It stays, page to
 * page, until they close it; closing it lasts for the rest of this sign-in. */
export const RecoveryCodeSignInNotice = () => {
  const [notice, setNotice] = useState(recoveryCodeSignIn);
  if (!notice) return null;

  const dismiss = () => {
    clearRecoveryCodeSignIn();
    setNotice(null);
  };

  return (
    <Box
      role="status"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        mx: 2,
        mt: 2,
        mb: 1,
        p: { xs: 1.5, sm: 2 },
        borderRadius: '14px',
        border: '1px solid rgba(243,191,77,0.45)',
        background: 'rgba(243,191,77,0.08)'
      }}
    >
      <KeyRounded sx={{ color: PT.gold, flexShrink: 0, mt: '1px' }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 14.5, fontWeight: 700, color: PT.text, lineHeight: 1.45 }}>
          You signed in with a recovery code
          {notice.remaining !== null && ` (${notice.remaining} left)`}. Set up 2FA on
          your new device.
        </Typography>
        <Link
          component={RouterLink}
          to="/member-portal/settings?tab=security"
          sx={{
            display: 'inline-block',
            mt: 0.5,
            fontSize: 14,
            fontWeight: 700,
            color: PT.teal,
            textDecorationColor: 'rgba(56,232,255,0.5)'
          }}
        >
          Open Settings → Security
        </Link>
      </Box>
      <IconButton
        onClick={dismiss}
        aria-label="Dismiss"
        size="small"
        sx={{ color: PT.textMuted, mt: '-4px', mr: '-4px', '&:hover': { color: PT.text } }}
      >
        <CloseRounded fontSize="small" />
      </IconButton>
    </Box>
  );
};
